export default "__VITE_ASSET__COE_J_Vv__"